import { IServiceEventMappingModel } from '../../../../models/index';
import {
  addServiceEventMapping,
  clearServiceEventMapping,
  deleteServiceEventMapping,
  duplicateServiceEventMaping,
  statusMessageClearMaping,
  updateServiceEventMapping
} from '../../../reducer/services/ServiceEventMappingReducer';
import {
  AddServiceEventMappingSuccess,
  ClearServiceEventMapping,
  DeleteServiceEventMapping,
  DeleteServiceEventMappingPayload,
  DuplicateServiceEventMapping,
  StatusMessageClearMaping,
  StatusMessageClearMapingPayload,
  UpdateServiceEventMapping,
  UpdateServiceEventMappingPayload
} from '../../types/services/ServiceEventsMappingTypes';

/**
 * Adds Service event association
 * @param reqObject : Payload
 */
export const addServiceEventMappings = (
  payload: IServiceEventMappingModel
): AddServiceEventMappingSuccess => ({
  type: addServiceEventMapping.type,
  payload
});

/**
 * Duplicate Service event association
 * @param payload : data
 */
export const duplicateServiceEventMappings = (
  payload: boolean
): DuplicateServiceEventMapping => ({
  type: duplicateServiceEventMaping.type,
  payload
});
/**
 * Update Service event association
 * @param payload : data
 */
export const updateServiceEventMappings = (
  payload: UpdateServiceEventMappingPayload
): UpdateServiceEventMapping => ({
  type: updateServiceEventMapping.type,
  payload
});

/**
 * Delete Service event association
 * @param payload : number
 */
export const deleteServiceEventMappings = (
  payload: DeleteServiceEventMappingPayload
): DeleteServiceEventMapping => ({
  type: deleteServiceEventMapping.type,
  payload
});

/**
 * Clear Service event association saga action
 */
export const clearServiceEventMappings = (): ClearServiceEventMapping => ({
  type: clearServiceEventMapping.type
});

export const statusMessageClearMapings = (
  payload: StatusMessageClearMapingPayload
): StatusMessageClearMaping => ({
  type: statusMessageClearMaping.type,
  payload
});
